import Alerts from './alerts/index'
import App from './app/index'
import Avatars from './avatars/index'
import Breadcrumbs from './breadcrumbs/index'
import Buttons from './buttons/index'
import Cards from './cards/index'
import Carousel from './carousel/index'
import Chips from './chips/index'
import ExpansionPanel from './expansion-panel/index'
import Dividers from './dividers/index'
import Footer from './footer/index'
import Forms from './forms/index'
import Grid from './grid/index'
import Icons from './icons/index'
import Lists from './lists/index'
import Menu from './menus/index'
import Modal from './modal/index'
import Toolbar from './toolbar/index'
import Overlay from './overlay/index'
import Pagination from './pagination/index'
import Parallax from './parallax/index'
import Progress from './progress/index'
import Sidebar from './sidebar/index'
import Slider from './sliders/index'
import Subheader from './subheaders/index'
import Stepper from './steppers/index'
import Tables from './tables/index'
import Tabs from './tabs/index'
import Transitions from './transitions/_index'
import Snackbar from './snackbars/index'

export default Object.assign({},
  Alerts,
  App,
  Avatars,
  Breadcrumbs,
  Buttons,
  Cards,
  Carousel,
  Chips,
  Dividers,
  ExpansionPanel,
  Footer,
  Forms,
  Grid,
  Icons,
  Lists,
  Menu,
  Modal,
  Toolbar,
  Overlay,
  Pagination,
  Parallax,
  Progress,
  Sidebar,
  Slider,
  Subheader,
  Stepper,
  Tables,
  Tabs,
  Transitions,
  Snackbar
)



// WEBPACK FOOTER //
// ./src/components/_index.js